import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useBusinessUnit } from "../../context/BusinessUnitContext";

const ConsultantRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { isLoaded, isConsultantPortal } = useBusinessUnit();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isLoaded) return null;
  if (!isConsultantPortal) return <Navigate to="/portal/dashboard" replace />;
  return children;
};

export default ConsultantRoute;
